module.exports = __webpack_public_path__ + "media/images/team/SBjoern-da3cb4f66aa75f5cf76d69ba9c1bd6e3.jpg";